export default __webpack_public_path__ + "static/media/win-overlay-gradient.84b8e148.png";